<template>
  <div>
    <NewStaffDialog :state="createState" @done="refresh" />

    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách người dùng" :link="[{ text: 'Người dùng', href: '../staffs' }]" />
      </div>
      <div class="flex-center">
        <!-- <v-btn v-if="$vuetify.breakpoint.mdAndUp" class="mr-2" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn> -->
        <v-btn
          v-if="$auth.policies['add-new-staff']"
          depressed
          dark
          color="#0D47A1"
          @click.stop="createState = !createState"
        >
          <v-icon left>add</v-icon>{{ titleBtn }}
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <StaffFilter @onFilterChanged="refresh($event)" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <StaffDataTable ref="table" />
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import NewStaffDialog from '@/modules/staff/NewStaffDialog'
import StaffDataTable from '@/modules/staff/StaffDataTable.vue'
import StaffFilter from '@/modules/staff/StaffFilter.vue'

export default {
  components: {
    Breadcrumbs,
    NewStaffDialog,
    StaffDataTable,
    StaffFilter
  },
  props: {
    role: String
  },
  data() {
    return {
      headers: [],
      draw: false,
      search: '',
      status: null,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      isLoading: false,
      createState: false
    }
  },
  async created() {
    this.isLoading = true
    this.fetchStaffsCount()
    this.fetchStaffs().then(() => {
      this.isLoading = false
    })
    await this.fetchRoles()
  },
  computed: {
    ...mapState('staff', ['staffs', 'count', 'staff']),
    members() {
      return this.staffs
    },
    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm người dùng'
      }
    },
    filters() {
      return [{ key: 'block', value: this.status }]
    }
  },
  methods: {
    ...mapActions('staff', ['fetchStaffs', 'fetchStaffsCount', 'setStaff', 'setStaffs', 'updateStaffs']),
    ...mapActions('role', ['fetchRoles']),
    updateDraw(draw) {
      this.draw = draw
    },
    async preview(user) {
      if (!user) return
      this.$refs.template.preview()
      this.previewUserId = user.id
    },
    getColor(status) {
      if (status === 'active') return 'green'
      else return 'red'
    },
    refresh(query) {
      this.$refs.table.refresh(query)
    }
  }
}
</script>
